var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    {
      [_vm.classNameActive]: _vm.enabled,
      [_vm.classNameDragging]: _vm.dragging,
      [_vm.classNameResizing]: _vm.resizing,
      [_vm.classNameDraggable]: _vm.draggable,
      [_vm.classNameResizable]: _vm.resizable
    },
    _vm.className
  ],style:(_vm.style),on:{"mousedown":_vm.elementMouseDown,"touchstart":_vm.elementTouchDown}},[_vm._l((_vm.actualHandles),function(item){return _c('div',{key:item,class:[_vm.classNameHandle, _vm.classNameHandle + '-' + item],style:(_vm.handleStyle(item)),on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleDown(item, $event)},"touchstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleTouchDown(item, $event)}}},[_vm._t(item)],2)}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }